<div class="user-settings">
  <div class="settings-nav">
    @for (option of settingsOptions; track option) {
      @if (showLink(option)) {
        <a
          [ngClass]="{'selected': selectedOption === option}"
          (keyup.enter)="selectedOption = option"
          (click)="selectedOption = option"
          tabindex="0"
          class="menu-option"
          >
          {{ settingsOptionsTranslations[option] | translate }}
        </a>
      }
    }

  </div>
  <div class="settings-menu">
    <mat-form-field class="go-select">
      <mat-select
        [(ngModel)]="selectedOption"
        disableOptionCentering
        panelClass="offsetPanel go-select-panel">
        @for (option of settingsOptions; track option) {
          @if (showLink(option)) {
            <mat-option
              [value]="option">
              {{ settingsOptionsTranslations[option] | translate }}
            </mat-option>
          }
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
    </mat-form-field>
  </div>
  <div class="settings-content" data-cy="settings-content">
    @switch (selectedOption) {
      @case (settingsOptions[0]) {
        <user-details></user-details>
      }
      @case (settingsOptions[1]) {
        <email-notifications></email-notifications>
      }
      @case (settingsOptions[2]) {
        <default-activity-settings [account]="account"></default-activity-settings>
      }
      @case (settingsOptions[3]) {
        <billing-history></billing-history>
      }
    }
  </div>
</div>
